<div class="" [formGroup]="reportsConfig">
    <div class="flex items-center gap-2 my-2">
        <p-checkbox formControlName="reportsEnabled" inputId="reportsEnabled" [binary]="true"/>
        <label for="reportsEnabled" class="text-sm">{{'fields.enable-reports' | translate}}</label>
    </div>

    <div class="mb-2">
      <p-iftalabel>
        <input pInputText class="w-full" id="reportsEmail" formControlName="reportsEmail" />
        <label for="reportsEmail">{{ 'fields.email' | translate }}</label>
      </p-iftalabel>
    </div>

    <p-divider />

    <p class="text-sm font-semibold mb-3">{{ 'fields.report-templates-v2' | translate }}</p>

    <div class="mb-2">
      <p-iftalabel>
        <p-select
          [options]="templateOptions()"
          optionLabel="label"
          optionValue="value"
          formControlName="templateMaturityMeasurement"
          styleClass="w-full"
          id="templateMaturity"
        />
        <label for="templateMaturity">{{ 'fields.template-maturity' | translate }}</label>
      </p-iftalabel>
    </div>

    <div class="mb-2">
      <p-iftalabel>
        <p-select
          [options]="templateOptions()"
          optionLabel="label"
          optionValue="value"
          formControlName="templateTemperatureMeasurement"
          styleClass="w-full"
          id="templateTemperature"
        />
        <label for="templateTemperature">{{ 'fields.template-temperature' | translate }}</label>
      </p-iftalabel>
    </div>

    <div class="mb-2">
      <p-iftalabel>
        <p-select
          [options]="templateOptions()"
          optionLabel="label"
          optionValue="value"
          formControlName="templateQualityControlReport"
          styleClass="w-full"
          id="templateQC"
        />
        <label for="templateQC">{{ 'fields.template-qc' | translate }}</label>
      </p-iftalabel>
    </div>
</div>

<div class="w-full text-center">
    <button pButton (click)="updateProject(reportsConfig.value)">{{ ('button.save') | translate}}</button>
</div>